export default __webpack_public_path__ + "static/instance-metrics-02-22a03b67d6d1013721dd90b4429c11eb.png";